import { Component, OnInit, Input, SimpleChanges, OnChanges } from '@angular/core';
import { faRedo } from '@fortawesome/free-solid-svg-icons';
import { CaptainService } from '../../captain.service';
import { ToasterType, Toaster } from 'src/app/shared/types';
import { ToasterService } from 'src/app/toaster.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-captain-mg-earnings',
  templateUrl: './captain-mg-earnings.component.html',
  styleUrls: ['./captain-mg-earnings.component.css']
})
export class CaptainMgEarningsComponent implements OnInit, OnChanges {
  @Input() riderMobile: string;
  @Input() riderId: string;

  mgShiftGroups: any[] = [];
  faRefresh = faRedo;
  public todayDate = this.formatDate(new Date());

  selectedDate: string = this.todayDate;

  constructor(
    private toasterService: ToasterService,
    public captainService: CaptainService,
    private router: Router
  ) {}

  ngOnInit() {
    this.fetchMgEarnings();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.fetchMgEarnings();
  }

  fetchMgEarnings() {
    if (!this.riderId) { return; }

    this.captainService.getMgEarnings(this.riderId, this.selectedDate).subscribe(result => {
      this.mgShiftGroups = Array.isArray(result) ? result : [];
    }, error => {
      this.toasterService.showToaster(new Toaster({
        type: ToasterType.WARNING,
        message: (error && error.error && error.error.metadata) || 'Unable to fetch MG earnings',
      }));
    });
  }

  refreshData() {
    this.fetchMgEarnings();
  }

  onDateChange(date: string) {
    this.selectedDate = date;
    this.fetchMgEarnings();
  }

  openOrderDetails(orderId: string) {
    if (!orderId) { return; }
    const newRelativeUrl = this.router.createUrlTree([`/order/${orderId}`]);
    const baseUrl = window.location.href.replace(this.router.url, '');
    window.open(baseUrl + newRelativeUrl, '_blank');
  }

  getProgressPercent(completed: number, goal: number): number {
    if (!goal) { return 0; }
    return Math.min(Math.round((completed / goal) * 100), 100);
  }

  formatTimestamp(ts: number): string {
    if (!ts) { return '-'; }
    const date = new Date(ts);
    return date.toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', hour12: true });
  }

  formatSlotTime(time: string): string {
    if (!time) { return ''; }
    const [hourStr, minStr] = time.split(':');
    let hour = parseInt(hourStr, 10);
    const period = hour >= 12 ? 'PM' : 'AM';
    if (hour > 12) { hour -= 12; }
    if (hour === 0) { hour = 12; }
    return `${hour.toString().padStart(2, '0')}:${minStr} ${period}`;
  }

  formatMgSlot(slotStr: string): string {
    if (!slotStr) { return '-'; }
    const parts = slotStr.split(' - ');
    if (parts.length !== 2) { return slotStr; }
    return `${this.formatSlotTime(parts[0])} \u2013 ${this.formatSlotTime(parts[1])}`;
  }

  formatDate(date: Date): string {
    const d = new Date(date);
    let day: any = d.getDate();
    let month: any = d.getMonth() + 1;
    if (month < 10) { month = '0' + month; }
    if (day < 10) { day = '0' + day; }
    return `${d.getFullYear()}-${month}-${day}`;
  }
}
